import classNames from 'classnames';
import { ENV_CONFIG } from 'config/environment';
import { getPathWithRef } from 'helpers/utils';
import { FC, ReactNode } from 'react';
import { FormContent } from 'screens/Forms/FormContent';
import { ButtonBrand } from 'components/ButtonBrand';
import { Image } from 'components/Image';

interface Props {
  title: string;
  subtitle: string;
  ctaText?: string;
  media?: string;
  isMonthly?: boolean;
  cta?: string;
  children?: ReactNode;
  formContent?: string;
  bgColor?: string;
  smallTitle?: boolean;
}

export const Hero: FC<Props> = ({
  title,
  subtitle,
  ctaText,
  media,
  isMonthly,
  cta = '',
  children,
  formContent,
  bgColor,
  smallTitle,
}) => {
  const handleCtaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (cta.startsWith('#')) {
      e.preventDefault();
      const targetId = cta.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const containerStyle = isMonthly
    ? ({
        '--hero-bg-image': `url(${ENV_CONFIG().CLOUD_STORAGE.URL}/backgrounds/monthly_bg.png)`,
      } as React.CSSProperties)
    : bgColor
      ? { background: bgColor }
      : undefined;

  return (
    <div
      className={classNames('hero-container', { 'hero-container--monthly': isMonthly })}
      style={containerStyle}
    >
      <div className="hero-content-row">
        <div className="hero-content-text">
          <div className="hero-text">
            <span className={classNames('hero-title h1-dtm color-white', { 'h2-dtm': smallTitle })}>
              {title}
            </span>
            <span className="hero-subtitle h4-text color-white">{subtitle}</span>
          </div>
          {formContent ? (
            <FormContent form={formContent} />
          ) : (
            <ButtonBrand
              $secondary
              href={getPathWithRef(cta)}
              onClick={handleCtaClick}
              className="hero-cta-button"
            >
              {ctaText}
            </ButtonBrand>
          )}
        </div>
        {media && (
          <div className="hero-content-image">
            {media.includes('.mp4') ? (
              <video
                className="hero-video"
                autoPlay
                loop
                muted
                playsInline
                id={`${title} Video`}
                controls
              >
                <source src={media} type="video/mp4" />
              </video>
            ) : (
              <Image alt={`${title} Image`} src={media} className="hero-image" />
            )}
          </div>
        )}
        {children && <div className="hero-content-right">{children}</div>}
      </div>
    </div>
  );
};
